var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5843 2.42891C19.1215 2.65024 19.6098 2.97533 20.0212 3.38558C20.4406 3.7981 20.7734 4.2902 21.0001 4.83302C21.2268 5.37585 21.3429 5.95848 21.3415 6.54675V7.96197C21.3415 8.1776 21.2558 8.3844 21.1033 8.53687C20.9509 8.68935 20.7441 8.775 20.5284 8.775C20.3128 8.775 20.106 8.68935 19.9535 8.53687C19.801 8.3844 19.7154 8.1776 19.7154 7.96197V6.54675C19.715 6.17137 19.6399 5.79983 19.4945 5.45378C19.349 5.10773 19.1361 4.79411 18.8682 4.53121C18.6002 4.26831 18.2826 4.06139 17.9339 3.92252C17.5851 3.78366 17.2122 3.71562 16.8369 3.72239C15.3088 3.75079 14.0655 5.03963 14.0655 6.59541V8.6725H14.2875C15.5603 8.6725 16.5921 9.70429 16.5921 10.9771V19.6001C16.5921 20.8729 15.5603 21.9047 14.2875 21.9047H4.96327C3.69049 21.9047 2.65869 20.8729 2.65869 19.6001V10.9771C2.65869 9.70429 3.69049 8.6725 4.96327 8.6725H12.4395V6.60235C12.4395 4.14075 14.4168 2.11919 16.8472 2.09593L16.8905 2.09572C17.4715 2.09435 18.0471 2.20758 18.5843 2.42891ZM10.3256 15.4476V17.0426C10.3256 17.2283 10.2519 17.4065 10.1206 17.5378C9.98923 17.6691 9.81113 17.7429 9.62542 17.7429C9.43971 17.7429 9.2616 17.6691 9.13028 17.5378C8.99896 17.4065 8.92519 17.2283 8.92519 17.0426V15.4476C8.65821 15.2934 8.44954 15.0555 8.33157 14.7707C8.21359 14.4858 8.19289 14.17 8.27268 13.8723C8.35247 13.5745 8.52829 13.3113 8.77287 13.1237C9.01746 12.936 9.31713 12.8343 9.62542 12.8343C9.93371 12.8343 10.2334 12.936 10.478 13.1237C10.7225 13.3113 10.8984 13.5745 10.9782 13.8723C11.0579 14.17 11.0372 14.4858 10.9193 14.7707C10.8013 15.0555 10.5926 15.2934 10.3256 15.4476Z",
    fill: "url(#paint0_linear_3117_249235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3117_249235",
    x1: 2.65869,
    y1: 12.0009,
    x2: 21.3415,
    y2: 12.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLock);
export default __webpack_public_path__ + "static/media/User_Lock.60bd052396194d59a1ce174519053563.svg";
export { ForwardRef as ReactComponent };